import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { WEB_COMPONENT_COMPANIES_GRID, WEB_COMPONENT_GZ_TITLE } from '../../../webcomponents.constants';
import { CompaniesGridWebComponent } from '../../companiesGrid';
import { CompanyTypeData } from '../../../company/types/company-type-data';
import { translateFn } from '../../../utils/translator.helper';

export class CompaniesAppView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $companiesGrid: CompaniesGridWebComponent;
    $title: HTMLElement;
    $sideMenuWrapper: HTMLElement;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $companiesGrid: this.shadow.querySelector(WEB_COMPONENT_COMPANIES_GRID),
      $title: this.shadow.querySelector(WEB_COMPONENT_GZ_TITLE),
      $sideMenuWrapper: this.shadow.querySelector('#grid-side-panel-wrapper'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.dom.$title.textContent = translateFn('Companies');
  }

  buildSuccessView({ companyTypes }: { companyTypes: CompanyTypeData[] }) {
    this.dom.$companiesGrid.propertiesSet = false;
    this.dom.$companiesGrid.companyTypes = companyTypes;
    this.dom.$companiesGrid.propertiesSet = true;

    this.dom.$companiesGrid.closeSettingsSideMenu();

    if (!this.dom.$companiesGrid.started) {
      this.dom.$companiesGrid.injectDependencies(this.dependencies);
      this.dom.$companiesGrid.start().then().catch(console.error);
    }
  }
}
